export default __webpack_public_path__ + "static/media/gallery18.9ad010e8.jpg";